import { API, graphqlOperation } from "aws-amplify";
import { GraphQLResult } from "@aws-amplify/api";
import { listLLMModels } from "../graphql/queries";
import { ListLLMModelsQuery } from "../API";

export async function fetchLLMModels(): Promise<GraphQLResult<ListLLMModelsQuery>> {
  return API.graphql(
    graphqlOperation(listLLMModels, {
      filter: {
        status: {
          eq: "active" // Only fetch active models
        },
        supported: {
          eq: true // Only fetch supported models
        }
      }
    })
  ) as Promise<GraphQLResult<ListLLMModelsQuery>>;
}
